import { jsxs as j, jsx as e } from "react/jsx-runtime";
import { RemoveCircleIcon as o } from "../Icons/circle/RemoveCircleIcon.js";
const l = ({ label: r, disabled: t, onClick: m }) => /* @__PURE__ */ j(
  "button",
  {
    className: "jm-group jm-flex jm-cursor-pointer jm-select-none jm-items-center jm-justify-center jm-gap-1 jm-rounded-full jm-border-none jm-bg-jutro-new-blue-100 jm-px-2 jm-py-1 jm-outline jm-outline-4 jm-outline-transparent hover:jm-bg-blue-200 focus-visible:jm-outline-blue-400 active:jm-bg-blue-300 disabled:jm-cursor-auto disabled:jm-bg-jutro-new-warm-gray-100",
    disabled: t,
    onClick: m,
    type: "button",
    children: [
      /* @__PURE__ */ e("div", { className: "jm-font-paragraph-1 jm-text-jutro-new-blue-900 group-disabled:jm-text-jutro-new-warm-gray-700", children: r }),
      /* @__PURE__ */ e("div", { className: "jm-flex jm-items-center jm-justify-center jm-text-jutro-new-blue-800 group-disabled:jm-text-jutro-new-warm-gray-700", children: /* @__PURE__ */ e(o, { size: "sm" }) })
    ]
  }
);
export {
  l as Pill
};
//# sourceMappingURL=index.js.map
